import { useState, useEffect } from "react";
import { getInstructorStatistics } from "../../api/lesson";

const useInstructorStatistics = (startDate, endDate) => {
  const [statisticsData, setStatisticsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getInstructorStatistics(startDate, endDate);
        setStatisticsData(data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [startDate, endDate]);

  return { statisticsData, loading, error };
};

export default useInstructorStatistics;
